import { Hero } from '@components/sections/Hero';
import { StatsBar } from '@components/sections/StatsBar';
import { About } from '@components/sections/About';
import { Vision } from '@components/sections/Vision';
import { Quote } from '@components/sections/Quote';
import { GetInvolved } from '@components/sections/GetInvolved';
import { Brochure } from '@components/sections/Brochure';
// import { Newsletter } from '@components/sections/Newsletter';

export function Home() {
  return (
    <>
      <Hero />
      <StatsBar />
      <About />
      <Vision />
      <Quote />
      <GetInvolved />
      <Brochure />
      {/* <Newsletter /> */}
    </>
  );
}